var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-results-container" },
    [
      !_vm.isSearchComponentReady ? _c("loading-overlay") : _vm._e(),
      _vm._v(" "),
      _vm.authResponse && _vm.isSearchComponentReady
        ? _c("div", [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 pt-4" }, [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "row search-text-" }, [
                  _c("div", { staticClass: "col-12 search-text" }, [
                    _vm.searchKeyword
                      ? _c("span", [
                          _vm._v("Search: "),
                          _c("span", { attrs: { title: _vm.searchKeyword } }, [
                            _vm._v(_vm._s(_vm.searchKeyword))
                          ])
                        ])
                      : _c("span", [_vm._v(" ")])
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isSearchComponentReady,
              expression: "isSearchComponentReady"
            }
          ]
        },
        [
          _c("div", { staticClass: "row eh-search-container search-wrapper" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("enterprise-search", {
                  key: _vm.componentKey,
                  attrs: {
                    env: _vm.appEnv,
                    "es-title": _vm.CONSTANTS.AUTODESK_ONE_ENTERPRISE_SEARCH,
                    "es-user-access-token": _vm.authResponse.accessToken,
                    "es-user-id-token": _vm.authResponse.idToken,
                    "user-id": _vm.authResponse.user.userName,
                    "user-email": _vm.authResponse.user.email,
                    "enable-url-params": true,
                    "customize-search": true,
                    "enable-employee-hub-search": true
                  },
                  on: {
                    onSearchKeywordChanged: _vm.searchKeywordChanged,
                    onWebComponentSuccess: _vm.onESComponentReady,
                    onWebComponentError: _vm.onESComponentError
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          !_vm.searchKeyword
            ? _c("div", { staticClass: "container" }, [_vm._m(1)])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "position-relative" }, [
      _c("div", { staticClass: "eh-search-background-card" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search-no-records-found" }, [
      _c("h4", [_vm._v("Please type keywords to search")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-576cc85e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-576cc85e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/SearchPage.vue
// module id = null
// module chunks = 